import photo1 from "/public/images/events/houlgate/stage-houlgate-24/photo1.webp";
import photo2 from "/public/images/events/houlgate/stage-houlgate-24/photo2.webp";
import photo3 from "/public/images/events/houlgate/stage-houlgate-24/photo3.webp";
import photo4 from "/public/images/events/houlgate/stage-houlgate-24/photo4.webp";
import photo5 from "/public/images/events/houlgate/stage-houlgate-24/photo5.webp";
import photo6 from "/public/images/events/houlgate/stage-houlgate-24/photo6.webp";
import photo7 from "/public/images/events/houlgate/stage-houlgate-24/photo7.webp";
import photo8 from "/public/images/events/houlgate/stage-houlgate-24/photo8.webp";
import photo9 from "/public/images/events/houlgate/stage-houlgate-24/photo9.webp";
import photo10 from "/public/images/events/houlgate/stage-houlgate-24/photo10.webp";
import photo11 from "/public/images/events/houlgate/stage-houlgate-24/photo11.webp";
import photo12 from "/public/images/events/houlgate/stage-houlgate-24/photo12.webp";
import photo13 from "/public/images/events/houlgate/stage-houlgate-24/photo13.webp";
import photo14 from "/public/images/events/houlgate/stage-houlgate-24/photo14.webp";
import photo15 from "/public/images/events/houlgate/stage-houlgate-24/photo15.webp";
import photo16 from "/public/images/events/houlgate/stage-houlgate-24/photo16.webp";
import photo17 from "/public/images/events/houlgate/stage-houlgate-24/photo17.webp";

export const stageHoulgate24Images = [
  {
    src: photo1,
    alt: "Stage Houlgate 2024 - Photo 1",
    format: "2:3" as const,
  },
  {
    src: photo2,
    alt: "Stage Houlgate 2024 - Photo 2",
    format: "3:2" as const,
  },
  {
    src: photo3,
    alt: "Stage Houlgate 2024 - Photo 3",
    format: "3:2" as const,
  },
  {
    src: photo4,
    alt: "Stage Houlgate 2024 - Photo 4",
    format: "2:3" as const,
  },
  {
    src: photo5,
    alt: "Stage Houlgate 2024 - Photo 5",
    format: "3:2" as const,
  },
  {
    src: photo6,
    alt: "Stage Houlgate 2024 - Photo 6",
    format: "3:2" as const,
  },
  {
    src: photo7,
    alt: "Stage Houlgate 2024 - Photo 7",
    format: "3:2" as const,
  },
  {
    src: photo8,
    alt: "Stage Houlgate 2024 - Photo 8",
    format: "3:2" as const,
  },
  {
    src: photo9,
    alt: "Stage Houlgate 2024 - Photo 9",
    format: "3:2" as const,
  },
  {
    src: photo10,
    alt: "Stage Houlgate 2024 - Photo 10",
    format: "3:2" as const,
  },
  {
    src: photo11,
    alt: "Stage Houlgate 2024 - Photo 11",
    format: "3:2" as const,
  },
  {
    src: photo12,
    alt: "Stage Houlgate 2024 - Photo 12",
    format: "3:2" as const,
  },
  {
    src: photo13,
    alt: "Stage Houlgate 2024 - Photo 13",
    format: "3:2" as const,
  },
  {
    src: photo14,
    alt: "Stage Houlgate 2024 - Photo 14",
    format: "3:2" as const,
  },
  {
    src: photo15,
    alt: "Stage Houlgate 2024 - Photo 15",
    format: "3:2" as const,
  },
  {
    src: photo16,
    alt: "Stage Houlgate 2024 - Photo 16",
    format: "3:2" as const,
  },
  {
    src: photo17,
    alt: "Stage Houlgate 2024 - Photo 17",
    format: "3:2" as const,
  },
];
